import { orgConstants } from "../constants";

export function loadOrganizationIndex(data) {
  return { type: orgConstants.LOAD_ORG, payload: data };
}

export function setOrg(data) {
  return { type: orgConstants.SET_ORG, payload: data };
}
